import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { loadSightingLink } from './deepLink';

export default function useSightingDeepLink({ accessReady, isAdmin, allowedLocations, onOpen }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('sighting');
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (!id || !accessReady) { setMessage(''); return undefined; }
    let active = true;
    setMessage('Opening sighting…');
    loadSightingLink(id, { isAdmin, allowedLocations }).then((entry) => {
      if (active) { onOpen(entry, { startWithFullClip: true }); setMessage(''); }
    }).catch((error) => { if (active) setMessage(error.message || 'Couldn’t open this sighting.'); });
    return () => { active = false; };
  }, [id, accessReady, isAdmin, allowedLocations, onOpen]);
  const clear = useCallback(() => {
    if (!id) return;
    const next = new URLSearchParams(searchParams);
    next.delete('sighting');
    setSearchParams(next, { replace: true });
  }, [id, searchParams, setSearchParams]);
  return { clear, message, linkedId: id };
}
